@if (initiativeForm) {
  <form [formGroup]="initiativeForm">
    <nb-card [ngStyle]="inWizard ? { width: '100%' } : {}">
      @if (!inWizard) {
      <nb-card-header>
        <div class="back-and-title">
          <div class="title" [innerHTML]="title | translate"></div>
          <span class="close-btn" (click)="confirmClose()" style="position:absolute;right:20px;top:50%;transform:translateY(-50%);font-size:16px;cursor:pointer;display:flex;align-items:center;">
            <i class="fa-light fa-x"></i>
          </span>
        </div>
      </nb-card-header>
      }
      <!-- FORM -->
      <nb-card-body>
        @if (!isAbandonType) {
          <div formArrayName="gains">
            <!-- GAIN FORMS -->
            <nb-accordion multiple class="mt-4">
              @for (gain of gains.controls; track gain; let first = $first; let i = $index) {
                <nb-accordion-item expanded="true" [disabled]="first">
                  <nb-accordion-item-header>
                      <span>
                        {{ "Gain #" | translate }}{{ i + 1 }}
                      </span>
                    <a
                      nbButton
                      ghost
                      status="primary"
                      (click)="removeGain(i)"
                      class="accordion-button"
                    >
                      <i class="fal fa-trash-can fa-xl"></i>
                    </a>
                  </nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <ng-container *ngTemplateOutlet="fields; context: { i, gain }"></ng-container>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              }
              <!-- ADD A NEW GAIN -->
              @if (canAddGain) {
                <nb-accordion-item expanded="false" disabled="true" (click)="addGain()"
                                   class="accordion-item-as-button">
                  <nb-accordion-item-header>
                      <span>
                        (+)
                        {{ "Add another gain" | translate }}
                      </span>
                  </nb-accordion-item-header>
                </nb-accordion-item>
              }
            </nb-accordion>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="abandonEnergyFossil" />
        }
      </nb-card-body>
      @if (hasUnsavedChanges() && !inWizard) {
        <nb-card-footer class="initiative wizard">
          <button nbButton (click)="validate()" class="wizard-next" [disabled]="!gains.valid">
            {{ "Save" | translate }}
          </button>
        </nb-card-footer>
      }
    </nb-card>

    <!-- FIELDS TEMPLATE -->
    <ng-template #fields let-i="i" let-gain="gain">
      <div class="form-group" [formGroup]="gain">

        <!-- FULL STOP (ABANDON ENERGIE FOSSILE) -->
        @if (isAbandonType && i === 0) {
          <div class="form-field toggle">
            <label for="full_stop">{{ 'Abandon energy fossil' | translate }}</label>
            <!-- Always enabled (true) and non-interactive for the fossil gain -->
            <nb-toggle status="success"
                       id="full_stop"
                       [checked]="true"
                       disabled
            ></nb-toggle>
          </div>
        }

        <!-- KWH GAIN -->
        @if (showAmountInput(i)) {
          <div class="form-field">
            <label for="theoretical_savings_full_year">{{ "Gain #{nb} in kWh/year" | translate: { nb: i + 1 } }}</label>
            <input
              nbInput
              id="theoretical_savings_full_year"
              type="number"
              formControlName="theoretical_savings_full_year"
              fullWidth
              integerOnly
              placeholder="-"
            >
            @if (isAbandonType && i !== 0) {
              <p class="caption status-hint m-0">{{ 'The value entered will correspond to a negative gain' | translate }}</p>
            }
          </div>
        }

        <!-- BUILDING CONSUMPTION WARNING -->
        @if (showAmountInput(i) && gainExceedsBuildingConsumption(i)) {
          <nb-alert status="danger" class="building-consumption-alert">
            {{ 'Warning, the gain is higher than the building consumption' | translate }}
          </nb-alert>
        }

        <!-- KG CO2 GAIN -->
        @if (showRefrigerantInput) {
          <div class="form-field">
            <label
              for="theoretical_greenhouse_gas_savings_full_year">{{ "Gain #{nb} in kgCO2/year" | translate: { nb: i + 1 } }}</label>
            <input
              nbInput
              id="theoretical_greenhouse_gas_savings_full_year"
              type="number"
              formControlName="theoretical_greenhouse_gas_savings_full_year"
              fullWidth
              integerOnly
            >
          </div>
        }
        <!-- ENERGY TYPE -->
        @if (showEnergyInput('ENERGY_SELECT')) {
          <div class="form-field" [nbSpinner]="(energyTypes$ | async)?.loading">
            <label for="energy_type_id">
              {{ 'Related energy' | translate }}
              ({{ 'core.utils.document_types.requirement_mandatory' | translate | lowercase }})
            </label>
            <nb-select
              id="energy_type_id"
              formControlName="energy_type_id"
              fullWidth
              [status]="hasDuplicateEnergyType(i) ? 'danger' : 'basic'"
            >
              @for (energyType of visibleEnergyTypes((energyTypes$ | async)?.data, i); track energyType.id) {
                <nb-option
                  [value]="energyType.id"
                  [disabled]="isEnergyTypeDisabled(energyType.id, i)"
                >
                  {{ energyType.name }}
                </nb-option>
              }
            </nb-select>
          </div>
        }

        <!-- ORIGIN -->
        <div class="form-field" [nbSpinner]="(gainOrigins$ | async)?.loading">
          <label for="gain_origin_id">{{ 'Source (optional)' | translate }}</label>
          <nb-select
            id="gain_origin_id"
            formControlName="gain_origin_id"
            fullWidth
          >
            @for (go of (gainOrigins$ | async)?.data; track go.id) {
              <nb-option [value]="go.id">
                {{ go.name }}
              </nb-option>
            }
          </nb-select>
        </div>
        <!-- PREICISION -->
        <div class="form-field" [nbSpinner]="(gainPrecisions$ | async)?.loading">
          <label for="gain_precision_id">{{ 'Usage precision (optional)' | translate }}</label>
          <nb-select
            id="gain_precision_id"
            formControlName="gain_precision_id"
            fullWidth
          >
            @for (gp of (gainPrecisions$ | async)?.data; track gp.id) {
              <nb-option [value]="gp.id">
                {{ gp.name }}
              </nb-option>
            }
          </nb-select>
        </div>
      </div>
    </ng-template>

    <ng-template #abandonEnergyFossil>
      <div class="mt-4" formArrayName="gains">
        <!-- GAIN 1: Fossil energy (is_electricity=false) -->
         
        @if (gains.controls.length >= 1) {
          <div class="form-group">
            <ng-container [formGroup]="gains.controls[0]">
              <div class="form-field" [nbSpinner]="(fossilEnergyTypes$ | async)?.loading">
                <label>
                  {{ 'Fossil fuel in question' | translate }}
                </label>
                <nb-select
                  formControlName="energy_type_id"
                  fullWidth
                  [status]="hasDuplicateEnergyType(0) ? 'danger' : 'basic'"
                >
                  @for (energyType of visibleEnergyTypes((fossilEnergyTypes$ | async)?.data, 0); track energyType.id) {
                    <nb-option [value]="energyType.id" [disabled]="isEnergyTypeDisabled(energyType.id, 0)">
                      {{ energyType.name }}
                    </nb-option>
                  }
                </nb-select>
              </div>

              <div class="form-field">
                <label>{{ "Gain on fossil fuels" | translate }}</label>
                <input
                  nbInput
                  readonly
                  type="number"
                  formControlName="theoretical_savings_full_year"
                  fullWidth
                  integerOnly
                  [placeholder]="'value will be filled automatically' | translate"
                >
              </div>
            </ng-container>

            <!--            New energy type-->
            <ng-container [formGroup]="gains.controls[1]">

              <div class="form-field" [nbSpinner]="(energyTypes$ | async)?.loading">
                <label>
                  {{ 'Substitute energy used' | translate}}
                </label>
                <nb-select
                  formControlName="energy_type_id"
                  fullWidth
                  [status]="hasDuplicateEnergyType(1) ? 'danger' : 'basic'"
                >
                  @for (energyType of visibleEnergyTypes((energyTypes$ | async)?.data, 1); track energyType.id) {
                    <nb-option [value]="energyType.id" [disabled]="isEnergyTypeDisabled(energyType.id, 1)">
                      {{ energyType.name }}
                    </nb-option>
                  }
                </nb-select>
              </div>
              <div class="form-field">
                <label>{{ "Increase in alternative energy consumption" | translate }}</label>
                <input
                  nbInput
                  type="number"
                  formControlName="theoretical_savings_full_year"
                  fullWidth
                  integerOnly
                  placeholder="-"
                  appNegativeOnly
                >
                <p class="caption status-hint mb-0">{{ 'The value entered will correspond to a negative gain' | translate }}</p>

              </div>
            </ng-container>
          </div>
        }
      </div>
    </ng-template>
  </form>
}
